
























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import {NodeDataType} from '@/system/nodes/enums';
import {NodeData} from '@/system/nodes/interfaces';
import enumsModule from '@/store/modules/enumsModule';
import {EnumData} from '@/interfaces/config';
import nodeModule from '@/store/modules/entities/nodeModule';

@Component({components: {Loading, SimpleDialog}})
export default class NodesTreeAddDialog extends Vue {
  loading = true;

  error = false;

  nodeModel: NodeData = {name: '', type: NodeDataType.Company, parent: {name: '', type: 6}};

  get title() {
    return (
      'Добавление нового узла в ' +
      (this.parentNode ? 'узел ' + this.parentNode.name : 'корень дерева')
    );
  }

  @Prop({required: false, default: null})
  parentNode!: NodeData | null;

  dialog = false;

  fieldRequiredRules = [(v: any) => !!v || 'Поле обязательно для заполнения'];
  formValid = false;

  btnIndex: number | null = null;
  btnActiveState = false;

  nodeType: EnumData<NodeDataType> | null = null;

  get nodeTypes() {
    if (this.parentNode && this.parentNode.type) {
      const parentType = this.parentNode.type;
      return enumsModule.nodeDataTypes.filter(item => item.value >= parentType);
    }
    return enumsModule.nodeDataTypes;
  }

  @Watch('dialog')
  async onDialog(value: boolean) {
    if (!value) this.updateBtnState();
    else {
      try {
        const {data} = await nodeModule.create();
        this.nodeModel = data;
        if (this.parentNode) this.nodeModel.parentId = this.parentNode.id;
        this.$nextTick(() => {
          if (this.$refs.form) (this.$refs.form as any).validate();
        });
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  }

  updateBtnState() {
    this.btnActiveState = this.dialog;
    this.btnIndex = this.dialog ? 0 : null;
  }

  onSubmit() {
    this.dialog = false;
    this.updateBtnState();
    this.$emit('submitForm', this.nodeModel);
  }

  onClickCancel() {
    this.dialog = false;
  }
}
